// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"e49aa14c","253":"31417264","822":"be95de68"}[chunkId] + ".chunk.js";
};